import React from 'react';
import { hot } from "react-hot-loader/root";
import {
    HashRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";

import About from "components/About";
import Content from "components/Content";
import Footer from "components/Footer";
import Header from "components/Header";
import Projects from "components/Projects";

import './App.scss';

const App: React.FC = () => {
  return (
    <Router>
        <Header />
        <Content>
            <Switch>
                <Route path="/about" component={About}/>
                <Route path="/projects" component={Projects}/>
                <Route render={() => <Redirect to="/about" />} />
            </Switch>
        </Content>
        <Footer />
    </Router>
  );
}

export default hot(App);
